import Notification from './notification.vue';
import NotificationTab from './notification-tab.vue';
import NotificationItem from './notification-item.vue';
Notification.Tab = NotificationTab;
Notification.Item = NotificationItem;

export default Notification;


// WEBPACK FOOTER //
// ./src/components/notification/index.js